module.exports = __webpack_public_path__ + "static/img/jiang.3132bac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang.jpg
// module id = Rqzj
// module chunks = 1